import produce from "../util/produce";

export const initialState = {
  loadResumeLoading: false,
  loadResumeDone: false,
  loadResumeError: null,
  loadAllResumesLoading: false,
  loadAllResumesDone: false,
  loadAllResumesError: null,
  loadCareerLoading: false,
  loadCareerDone: false,
  loadCareerError: null,
  resume: null,
  allResumes: null,
  career: null,
};

// 이 문자열들은 redux-saga가 action.type 문자열 값으로만 구분합니다.
// 예전엔 LOAD_RESUME_REQUEST/LOAD_CAREER_REQUEST가 공개 사이트 쪽
// (front/src/reducers/userResume.js, userCareer.js)과 값이 완전히
// 똑같아서, 공개 사이트가 자기 화면(예: 프로젝트 성과 관리)에서 정상적인
// LOAD_CAREER_REQUEST를 보낼 때마다 이 관리자 saga도 함께 반응해
// /admin/individual/career, /admin/individual/resume로 불필요한 요청을
// 보내고 401 오류를 냈습니다(같은 스토어·같은 saga 미들웨어를 쓰기
// 때문에 문자열이 같으면 구분이 안 됨). 관리자 전용 값으로 접두어를
// 붙여 충돌을 없앴습니다.
export const LOAD_RESUME_REQUEST = "ADMIN_LOAD_RESUME_REQUEST";
export const LOAD_RESUME_SUCCESS = "ADMIN_LOAD_RESUME_SUCCESS";
export const LOAD_RESUME_FAILURE = "ADMIN_LOAD_RESUME_FAILURE";

export const LOAD_ALLRESUMES_REQUEST = "LOAD_ALLRESUMES_REQUEST";
export const LOAD_ALLRESUMES_SUCCESS = "LOAD_ALLRESUMES_SUCCESS";
export const LOAD_ALLRESUMES_FAILURE = "LOAD_ALLRESUMES_FAILURE";

export const LOAD_CAREER_REQUEST = "ADMIN_LOAD_CAREER_REQUEST";
export const LOAD_CAREER_SUCCESS = "ADMIN_LOAD_CAREER_SUCCESS";
export const LOAD_CAREER_FAILURE = "ADMIN_LOAD_CAREER_FAILURE";

const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case LOAD_RESUME_REQUEST:
        draft.loadResumeLoading = true;
        draft.loadResumeError = null;
        draft.loadResumeDone = false;
        break;
      case LOAD_RESUME_SUCCESS:
        draft.loadResumeLoading = false;
        draft.resume = action.data;
        draft.loadResumeDone = true;
        break;
      case LOAD_RESUME_FAILURE:
        draft.loadResumeLoading = false;
        draft.loadResumeError = action.error;
        break;
      case LOAD_CAREER_REQUEST:
        draft.loadCareerLoading = true;
        draft.loadCareerError = null;
        draft.loadCareerDone = false;
        break;
      case LOAD_CAREER_SUCCESS:
        draft.loadCareerLoading = false;
        draft.career = action.data;
        draft.loadCareerDone = true;
        break;
      case LOAD_CAREER_FAILURE:
        draft.loadCareerLoading = false;
        draft.loadCareerError = action.error;
        break;
      case LOAD_ALLRESUMES_REQUEST:
        draft.loadAllResumesLoading = true;
        draft.loadAllResumesError = null;
        draft.loadAllResumesDone = false;
        break;
      case LOAD_ALLRESUMES_SUCCESS:
        draft.loadAllResumesLoading = false;
        draft.allResumes = action.data;
        draft.loadAllResumesDone = true;
        break;
      case LOAD_ALLRESUMES_FAILURE:
        draft.loadAllResumesLoading = false;
        draft.loadAllResumesError = action.error;
        break;

      default:
        return state;
    }
  });
};

export default reducer;
